<template>
  <div v-if="!FirstName" class="loading-shade">
    <div class="loading-spinner"></div>
  </div>

  <div class="appWrapper" v-if="FirstName">

    <div class="holder">
        <div class="thankyouWrapper">
          <h3>Add to Your Calendar!</h3>

          <p class="mt-4">
            Get ready for thrilling expeditions with our Adventure Club! Add our upcoming events to your calendar effortlessly. Click below to download the iCal file or manually add to your calendar.
          </p>
          
          <button @click="addEventToCalendar" type="button" class="mt-4 ctaPrimary font-icon formSubmitBtn" >Add to  Calendar</button>


        </div>

    </div>
  </div>
</template>

<script>
import axios from "axios";
import { base_be_url } from "@/utils/api";
import { dietaryOptions } from "@/utils/constants";
import ical from "ical-generator";

// import adobeAnalytics from "@/plugin/analytics";

export default {
  data() {
    return {
      isFocused: false,
      sales_force_id: this.$route.query.sales_force_id,
      Title: "",
      Email: "",
      LastName: "",
      FirstName: "",
      NSA_Bookingdate__c: "",
      NSA_DrivingExperience__c: "",
      Region__c: "",
      MobilePhone: "",
      isMobileValid: true,
      isError: false,
      errorMessage: "",
      showThankYouMessage: false,
      dietaryOptions: dietaryOptions,
      selectedDietaryRequirements: [],
      dietaryRequirementsOnSubmit: false,
    };
  },
  methods: {
    addEventToCalendar() {
      const event = ical({
        domain: "nissan.co.za",
        name: "ADVENTURE CLUB",
        timezone: "Africa/Johannesburg", // South Africa timezone
        location: this.Region__c,
      });

      const startDate = new Date(this.NSA_Bookingdate__c); // Current date
      const endDate = new Date(this.NSA_Bookingdate__c);
      endDate.setDate(startDate.getDate() + 1); // Setting end date to tomorrow

      event.createEvent({
        start: startDate,
        end: endDate,
        location: this.Region__c,
        summary: "ADVENTURE CLUB",
        allDay: true, // All-day event
      });

      const calendarData = event.toString();
      const blob = new Blob([calendarData], {
        type: "text/calendar;charset=utf-8",
      });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "event.ics");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    fetchData() {
      try {
        const salesForceId = this.$route.query.sales_force_id;
        const apiUrl = `${base_be_url}?sales_force_id=${salesForceId}`;

        axios.get(apiUrl).then((response) => {
          // Handle the successful response
          const res = response.data;
          if (res.success && res.response.totalSize > 0) {
            this.FirstName = res.response.records[0].FirstName;
            this.LastName = res.response.records[0].LastName;
            this.NSA_Bookingdate__c =
              res.response.records[0].NSA_Bookingdate__c;
            this.NSA_DrivingExperience__c =
              res.response.records[0].NSA_DrivingExperience__c;
            this.Region__c = res.response.records[0].Region__c;
            this.MobilePhone = res.response.records[0].MobilePhone;
          } else {
            this.$router.push(`/`);
          }
        });
      } catch (error) {
        console.log("ower not found");
        this.$router.push("/");
      }
    },
  },
  mounted() {
    // Fetch data when the component is mounted
    this.fetchData();
    // const form = document.getElementById("guestForm");
    // if (!form) return; // Ensure the form element exists
    // Get all input, select, checkbox, and radio elements within the form
    setTimeout(() => {
      // alert()
      this.addEventToCalendar()
    }, 1000);
    // Add focus event listener to each element
  
  },
};
</script>

<style scoped>
.mt-4{
  margin-top: 2rem;
}

</style>
